import { useState } from "react";

import { ExternalUser } from "models/customers/customers";
import ExternalUsersEdit from "./ExternalUsersEdit";
import ExternalUsersSummary from "./ExternalUserSummary";

type Props = {
  users: ExternalUser[];
  collapsed: boolean;
  onItemAdded: (user: Partial<ExternalUser>, isNew?: boolean) => void;
  onItemRemove: (email: string) => void;
  validUserData?: any;
  resetValidUserData?: () => void;
  info?: string;
};

export default function ExternalUsers({
  users,
  collapsed,
  onItemAdded,
  onItemRemove,
  validUserData,
  resetValidUserData,
  info
}: Props) {
  const [visible, setVisible] = useState(collapsed ? "summary" : "edit");

  const handleSaveClick = () => {
    setVisible("summary");
  };

  const visibleModule =
    visible === "summary" ? (
      <ExternalUsersSummary users={users} />
    ) : (
      <ExternalUsersEdit
        showSaveButton={collapsed}
        onSaveClick={handleSaveClick}
        externalUsers={users}
        onItemAdded={onItemAdded}
        onItemRemove={onItemRemove}
        validUserData={validUserData}
        resetValidUserData={resetValidUserData}
        info={info}
      />
    );


    return (
        <div>
          {visibleModule}
        </div>
      ); 
}
